var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('nevron-file-field',_vm._g(_vm._b({attrs:{"allowedFileTypes":_vm.imageExtensions,"title":_vm.title,"file":_vm.image,"decoration":_vm.decoration}},'nevron-file-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }